module.exports = __webpack_public_path__ + "img/Zeltbauen.409da06c.svg";